import { useShiki } from '../../hooks/useShiki'
import { stripInlineStyleTransformer } from '../../lib/shiki-transformers'

export default function CodeBlock({ className, children }) {
  const { highlighter, loading } = useShiki()
  const lang = className?.replace(/^language-/, '') || 'text'

  if (loading || !highlighter) {
    return (
      <pre className="bg-zinc-800 rounded p-4 text-xs font-mono text-zinc-300 overflow-x-auto my-3">
        <code>{children}</code>
      </pre>
    )
  }

  const html = highlighter.codeToHtml(children, {
    lang,
    theme: 'github-dark',
    transformers: [stripInlineStyleTransformer()],
  })

  return (
    <div
      className="my-3 rounded overflow-x-auto text-sm [&_pre]:p-4 [&_pre]:m-0"
      dangerouslySetInnerHTML={{ __html: html }}
    />
  )
}
